// Donation configuration
// PayPal: uses standard PayPal donate link with business email (no API key needed)

export const DONATE = {
  paypalEmail: 'josephmichaelkress@gmail.com',
  paypalUrl:
    'https://www.paypal.com/donate/?business=josephmichaelkress@gmail.com&item_name=Drug+Awareness+USA+-+Educational+Mission&currency_code=USD',
  headline: 'Help Fund Our Educational Mission',
  body:
    'Your voluntary contribution helps us create free drug awareness resources, maintain our website, and expand educational outreach. Drug Awareness USA is a sole proprietorship, so contributions are not tax-deductible charitable donations. Thank you for helping us make reliable educational resources available to more people.',
  amounts: [25, 50, 100, 250],
};
